import {LangEnum} from '../../enums/utils';
import {IAddress} from '../../interfaces/address/address.interface';
import {AppointmentTypeEnum} from '../appointment';
import {ExpertPrefixEnum, ExpertProfileStatusEnum, IExpertPersonalData, IExpertTraining} from '../expert';
import {IPhoneNumber} from '../../interfaces/phone-number/phone-number.interface';

export class IExpertPublicProfile {
    // tslint:disable-next-line:variable-name
    _id: string;
    userId: string;
    clinicId: string;
    specializationId: string;
    verified: boolean;
    appointmentsType: AppointmentTypeEnum[];
    expertTraining: IExpertTraining[];
    status?: ExpertProfileStatusEnum;
    publicPhotoUrl: string;
    about: string;
    specializationName: string;
    timeBlockAvailable: number[];
    address: IAddress[];
    phones: IPhoneNumber[];
    prefix?: ExpertPrefixEnum;
    professionalLicensesId: string[];
    personalData: IExpertPersonalData;
    // opinionScore: ;
    languages: LangEnum[];
    globalScore: number;
    acceptedTerms: boolean;
    createdAt?: Date;
    updatedAt?: Date;
}
